import { formatTimestampView } from '../utils/functions';
// columns person
export const PersonColumns = [
    /*{
        // aus den columns id entfernen, wenn sie nicht in der Tabelle erscheinen soll
        Header: 'Id', 
        accessor: 'id_person',
        disableFilters: true, // Filtermoeglichkeit für id entfernt
        sticky: 'left' // Spalte links fixieren
    },*/
    {
        Header: 'Benutzername',
        accessor: 'username',
        sticky: 'left' // Spalte links fixieren
    },
    {
        Header: 'Nachname',
        accessor: 'lastname',        
    },
    {
        Header: 'Vorname',
        accessor: 'firstname',
    },  
    {
        Header: 'E-Mail',
        accessor: 'email',
    }, 
    {
        Header: 'Rolle',
        accessor: 'role_name', // dropdown - wird nur in Tabelle angezeigt
    },
    {
        Header: 'Institution',
        accessor: 'institution_name', // dropdown - wird nur in Tabelle angezeigt
    },
    {
        Header: 'Letzte Änderung',
        accessor: 'timestamp',
        Cell: ({ value }) => formatTimestampView(value),
    },
]
